<template>
    <ac-modal title="Manage Plan" ref="modalRef" :size-class="'modal-md'">
        <template>
            <div class="form-group patient-viewer">
                <h4>Future Plan(s)</h4>
                <div v-if="futurePlans && futurePlans.length" >
                    <div v-for="fp in futurePlans" :key="fp.consumerPlanId" class="infogroup">
                        <label>Plan Name:</label>{{fp.planName}}<br/>
                        <label>Plan Id:</label>{{fp.planId}}<br/>
                        <label>Provider Name:</label>{{fp.physicianName}}<br/>
                        <label>Provider Entity Id:</label>{{fp.providerEntityId}}<br/>
                        <label>Effective Date:</label>{{fp.effectiveDate | shortDate}}<br/>
                        <label>End Date:</label>{{fp.endDate | shortDate}}
                    </div>
                </div>
                <div v-else>
                    Does not have a future plan
                </div>
                <h4>Current Plan(s)</h4>
                <div v-if="currentPlans && currentPlans.length">
                    <div v-for="cp in currentPlans" :key="cp.consumerPlanId" class="infogroup">
                        <label>Plan Name:</label>{{cp.planName}}<br/>
                        <label>Plan Id:</label>{{cp.planId}}<br/>
                        <label>Provider Name:</label>{{cp.physicianName}}<br/>
                        <label>Provider Entity Id:</label>{{cp.providerEntityId}}<br/>
                        <label>Effective Date:</label>{{cp.effectiveDate | shortDate}}<br/>
                        <label>End Date:</label>{{cp.endDate | shortDate}}
                    </div>
                    <div v-if="futurePlans && futurePlans.length">
                        <div class="form-check" style="margin-top: 10px;">
                            <input type="checkbox" class="form-check-input" id="extend" v-model="extendCurrentPlan" />
                            <label class="form-check-label" for="extend">&nbsp;Extend the current plan(s) (remove end date)</label>
                        </div>
                    </div>
                </div>
                <div v-else>
                    Does not have a current plan
                </div>
            </div>
            <div class="button-box" style="margin-top: 10px;">
                <ac-button class="btn btn-sm btn-red" :action="closeModal">CLOSE</ac-button>
                <ac-button v-if="futurePlans && futurePlans.length" class="btn btn-sm btn-green" :action="updatePlan">REMOVE FUTURE PLAN(S)</ac-button>
            </div>
        </template>
    </ac-modal>
</template>

<script>
    import {common} from "../../../../global/common.js";
    import {api} from "../../../../global/framework/api.js";
    import consultantVue from '../../../consultant/consultant.vue';

    export default {
        name: "ManagePlanModal",
        data() {
            return {
                viewOnly: false,
                consumerId: null,
                currentPlans: [],
                futurePlans: [],
                extendCurrentPlan: false,
            };
        },
        methods: {
            async showModal(consumer) {
                var data = await api.get("Admin", consumer.consumerId, "GetConsumerPlans");
                // console.log("ManagePlanModal showModal data", data);
                this.consumerId = consumer.consumerId;
                this.currentPlans = data.currentPlans || [];
                this.futurePlans = data.futurePlans || [];
                this.$refs.modalRef.open();
            },
            closeModal() {
                this.$refs.modalRef.close();
            },
            async updatePlan() {
                let result = await api.postWithId('Admin', this.consumerId, 'RemoveFuturePlan/' + this.extendCurrentPlan);
                if(result) {
                    this.closeModal();
                }
            }
        }
    }
</script>

<style scoped>
    .modal-footer {
        padding-left: 0;
        padding-right: 0;
    }
    .patient-viewer label:not(.form-check-label) {
        font-weight: bold;
        display: inline-block;
        width: 140px;
    }
    .infogroup {
        margin-bottom: 20px;
    }
</style>